import {
  useRoute as originUseRoute,
  type RouteProp,
  type ParamListBase,
} from '@react-navigation/native';

export const useRoute = <
  T extends ParamListBase,
  F extends keyof ParamListBase,
>() => originUseRoute<RouteProp<T, F> & { instanceId?: string }>();
